import React, { useEffect, useState } from 'react';
import { CalendarClock, MapPin, Video, Check } from 'lucide-react';
import { listEvents, rsvpEvent, myEvents } from '../api';
import { useToast } from '../hooks/use-toast';

const Events = () => {
  const [events, setEvents] = useState([]);
  const [mine, setMine] = useState([]);
  const { toast } = useToast();
  const authed = !!localStorage.getItem('pe_cust_token');

  const load = async () => {
    setEvents(await listEvents());
    if (authed) { try { setMine(await myEvents()); } catch { /* */ } }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);
  const isRsvped = (id) => mine.some((e) => e.id === id);

  const toggle = async (ev) => {
    if (!authed) { toast({ title: 'Sign in to RSVP', description: 'Create a free account to reserve your spot.' }); return; }
    try { const r = await rsvpEvent(ev.id); await load(); toast({ title: r.rsvped ? 'You\u2019re on the list! \u2728' : 'RSVP removed' }); }
    catch { toast({ title: 'Could not RSVP' }); }
  };

  return (
    <div className="pt-28 pb-24 min-h-screen">
      <div className="max-w-6xl mx-auto px-5">
        <div className="text-center mb-12">
          <p className="font-jost text-xs tracking-[0.4em] text-[#ff4da6] uppercase mb-3">Gather · Learn · Heal</p>
          <h1 className="font-cinzel text-4xl md:text-6xl text-gold-gradient">Events & Webinars</h1>
          <div className="gold-divider mt-4" />
          <p className="font-cormorant text-xl text-[#f5ecd9]/70 max-w-2xl mx-auto mt-5">Live classes, sound baths, and online sessions with the Prestige Elements community.</p>
        </div>
        {events.length === 0 ? (
          <p className="text-center font-cormorant text-xl text-[#f5ecd9]/50">No upcoming events right now — check back soon.</p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {events.map((ev) => (
              <div key={ev.id} data-testid={`event-card-${ev.id}`} className="card-glass rounded-2xl p-6 flex flex-col">
                {ev.image && <img src={ev.image} alt={ev.title} className="rounded-xl mb-4 h-40 w-full object-cover" />}
                <span className="font-jost text-[10px] uppercase tracking-widest text-[#ff4da6]">{ev.type} · {ev.price > 0 ? `$${ev.price}` : 'Free'}</span>
                <h3 className="font-cinzel text-xl text-[#f5ecd9] mt-2">{ev.title}</h3>
                <p className="font-jost text-xs text-[#f5ecd9]/50 mt-2 flex items-center gap-1"><CalendarClock className="h-3.5 w-3.5" /> {ev.date} {ev.time}</p>
                {ev.location && <p className="font-jost text-xs text-[#f5ecd9]/50 mt-1 flex items-center gap-1"><MapPin className="h-3.5 w-3.5" /> {ev.location}</p>}
                <p className="font-cormorant text-lg text-[#f5ecd9]/65 mt-3 flex-1">{ev.description}</p>
                <div className="flex items-center gap-2 mt-4">
                  <button data-testid={`rsvp-${ev.id}`} onClick={() => toggle(ev)} className={`text-[11px] uppercase tracking-widest px-4 py-2 rounded-full ${isRsvped(ev.id) ? 'border border-[#7bb661]/40 text-[#7bb661] flex items-center gap-1' : 'text-[#0a0708] font-semibold bg-gradient-to-r from-[#d4af37] to-[#f0d582]'}`}>{isRsvped(ev.id) ? <><Check className="h-3.5 w-3.5" /> Going</> : 'RSVP'}</button>
                  {ev.link && isRsvped(ev.id) && <a href={ev.link} target="_blank" rel="noreferrer" className="text-[11px] uppercase tracking-widest px-4 py-2 rounded-full border border-[#d4af37]/40 text-[#f0d582] flex items-center gap-1"><Video className="h-3.5 w-3.5" /> Join</a>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Events;
